<template>
  <el-container>
    <el-aside class="leftMenuContainer" width="-">
      <!--左侧工作区-->
      <el-col :span="24">
        <leftMenu activeIndex='4'></leftMenu>
      </el-col>
    </el-aside>

    <el-main class="work_container ">
      <div class="recyclePage">

        <el-row style="clear:both;height:40px"></el-row>

        <el-row>
          <el-col :span="22" :offset="1">
            <el-row>
              <el-col :span="12" class="t_l">

                <span class="pageTitle">我的回收站</span>

                <div class="pageDesc">
                  文件保留7天后将彻底删除
                </div>
              </el-col>
              <el-col :span="8" class="t_r">
                <el-radio-group v-model="resourceType" size="large" @change="changeType()">
                  <el-radio-button label="NEWS">
                    我的文章
                  </el-radio-button>
                  <el-radio-button label="METRAIL">
                    我的素材
                  </el-radio-button>

                </el-radio-group>
              </el-col>
              <el-col :span="4" class="t_r">
                <el-button @click="clearDialogVisible = true" size="mini"><span
                    class="claerRecycle"></span>清空回收站</el-button>
              </el-col>
            </el-row>
            <el-row style="clear:both;height:10px"></el-row>
            <br> <br>
            <el-row>
              <div class=" infinite-list" v-infinite-scroll="getRecycleArticle" :infinite-scroll-delay=500
                :infinite-scroll-distance=100 :infinite-scroll-immediate=true :infinite-scroll-disabled='infiniteFinish'
                style="overflow:auto;height: calc(100vh - 166px);">
                <el-table :data="articles" highlight-current-row style="width: 100%">
                  <el-table-column width="50" type="selection" label="操作">

                  </el-table-column>
                  <el-table-column label="标题">
                    <template slot-scope="scope">
                      <div :class="'tag_' + scope.row.resourceType"></div>
                      <span v-if="scope.row.resourceType === 'METRAIL'" :class="'tag ' + scope.row.tag"> {{ scope.row.tag
                      }}</span>

                      {{ scope.row.title ||
                        '【未设置标题】' }}
                    </template>
                  </el-table-column>

                  <el-table-column property="createTime" label="删除时间" width="180">
                  </el-table-column>

                  <el-table-column label="操作" width="160">
                    <template slot-scope="scope">
                      <el-link type="primary"
                        @click="resetArticle(scope.row.id, scope.$index, scope.row.resourceType, scope.row.folderId)">恢复文件</el-link>
                      <el-link type="primary">|</el-link>
                      <el-link type="danger" @click="toDeleteArticle(scope.row.id, scope.$index)">彻底删除</el-link>
                    </template>
                  </el-table-column>
                  <template slot="empty">
                    <div class="noFile"></div>
                    <div style="font-size: 12px;
font-weight: 400;
letter-spacing: 0px;
line-height: 17.38px;
color: rgba(213, 221, 234, 1);
text-align: center;">已被删除的文章，素材将会暂存在这里<br />您可以在删除后的7天内将内容恢复到原位置</div>
                  </template>
                </el-table>
                <div style="clear:both"></div>
                <template v-if="infiniteFinish">
                  <div class="noData" v-if="articles.length > 0">
                    <i class="iconfont">&#xe629;</i>
                    数据加载完毕!
                  </div>
                </template>
                <template v-else>
                  <div class="noData">
                    <span class="icon_run">
                      <i class="iconfont">&#xe67b;</i>
                    </span>数据加载中...
                  </div>
                </template>
              </div>
              <br>

            </el-row>
            <br>
          </el-col>
        </el-row>
      </div>

      <!---删除警告-->
      <el-dialog :visible.sync="deleteDialogVisible" custom-class="dangerDialog" :close-on-click-modal="false"
        title="彻底删除文件" :close-on-press-escape="false">
        <div class="content">您正在将此文件彻底删除，删除后则无法恢复次文件，请谨慎操作！</div>
        <el-row style="clear:both;min-height:20px;text-align:left">
        </el-row>
        <span slot="footer" class="dialog-footer">
          <el-button @click="deleteDialogVisible = false">取 消</el-button>
          <el-button @click="deleteArticle" class="dangerBtn">彻底删除</el-button>
        </span>
      </el-dialog>

      <!---清空回收站-->
      <el-dialog :visible.sync="clearDialogVisible" custom-class="dangerDialog" :close-on-click-modal="false"
        title="清空回收站" :close-on-press-escape="false">
        <div class="content">您正在清空回收站，清空后文件将无法找回，请谨慎操作！</div>
        <el-row style="clear:both;min-height:20px;text-align:left">
        </el-row>
        <span slot="footer" class="dialog-footer">
          <el-button @click="clearDialogVisible = false">取 消</el-button>
          <el-button @click="clearRecycle" class="dangerBtn">清空回收站</el-button>
        </span>
      </el-dialog>

    </el-main>
  </el-container>
</template>

<script>
import xyCard from '../components/xy_card'
import leftMenu from '../components/left_menu.vue'
export default {
  name: 'recycle',
  data: function () {
    return {
      keyword: '',
      lastId: '-1',
      infiniteFinish: false,
      articles: [],
      allSelectFlag: false,
      resourceType: 'NEWS',
      deleteDialogVisible: false,
      clearDialogVisible: false,
      curId: '',
      curIndex: ''

    }
  },
  methods: {
    clearRecycle () {
      let _this = this
      this.axios.get(`/webApi/v3/resourceRecycle/clearRecycle`).then((response) => {
        _this.articles = []
        _this.clearDialogVisible = false
      })
    },

    changeType () {
      this.articles = []
      this.lastId = -1
      this.getRecycleArticle()
    },

    getRecycleArticle () {
      let _this = this
      this.axios.get(`/webApi/v3/resourceRecycle/list?recycleId=${this.lastId}&resourceType=${this.resourceType}`).then((response) => {
        if (response.data === null || response.data.length < 10) {
          _this.infiniteFinish = true
        }
        _this.articles = _this.articles.concat(response.data)
        if (_this.articles && _this.articles.length > 0) {
          _this.lastId = _this.articles.slice(-1)[0].id
        }
      })
    },
    toDeleteArticle (id, index) {
      this.curId = id
      this.curIndex = index
      this.deleteDialogVisible = true
    },
    // 删除文章
    deleteArticle () {
      let _this = this
      this.axios.get('/webApi/v3/resourceRecycle/deleteArticle?recycleId=' + this.curId).then((response) => {
        this.$message({
          type: 'success',
          message: '删除成功'
        })
        _this.deleteDialogVisible = false
        _this.articles.splice(this.curIndex, 1)
      })
    },
    // 还原文章
    resetArticle (id, index, type, folderId) {
      let _this = this
      let newpage
      if (type === 'NEWS' || type === 'FOLDER') {
        newpage = this.$router.resolve({ path: `/articles?fid=${folderId}` })
      }
      if (type === 'METRAIL') {
        newpage = this.$router.resolve({ path: '/material' })
      }
      this.axios.get('/webApi/v3/resourceRecycle/resetArticle?recycleId=' + id).then((response) => {
        _this.$message({
          type: 'success',
          message: `已恢复到原位置&nbsp;<a href="${newpage.href}">立即打开</a>`,
          customClass: 'recycleMsg',
          dangerouslyUseHTMLString: 'true'
        })
        _this.articles.splice(index, 1)
      })
    }

  },
  components: {

    xyCard,
    leftMenu
  },
  mounted () {
    this.getRecycleArticle()
  },
  watch: {

  }
}
</script>
<style lang="less">
.recycleMsg {
  min-width: 0px;

  height: 21px !important;
  opacity: 1;
  border-radius: 18px;
  background: rgba(165, 214, 63, 1);

  .el-message__content {
    color: white;

    a {
      color: rgba(42, 130, 228, 1);
      text-decoration: none;
    }
  }

}
</style>
<style lang="less" scoped>
.noFile::after {
  content: "还没有任何垃圾文件";
  margin: auto;
  position: absolute;
  bottom: 0px;
  left: 0px;
  width: 140px;
  text-align: center;
  display: inline-block;
}

.work_container {
  padding: 0px;

}

.recyclePage {
  background-color: white;
  margin-left: 20px;

  .claerRecycle {
    background-image: url("../assets/imgs/writepage_icon.png");
    width: 24px;
    height: 24px;
    display: inline-block;
    background-size: 200%;
    background-position: 0px -498px;
    vertical-align: middle;
  }

  .pageDesc {
    font-size: 12px;
    color: #999999;
    display: inline-block;
    margin-left: 10px;
  }
}
</style>



// WEBPACK FOOTER //
// src/app/recycle.vue